import { useEffect, useState } from "react";
import { CombinedError, useQuery } from "urql";

import { graphql } from "@/gen";
import { SearchTournamentSeriesQuery } from "@/gen/graphql";

export type TournamentSeries = SearchTournamentSeriesQuery["searchTournamentSeries"][number];

type UseSearchTournamentSeriesResult = {
    tournamentSeries: TournamentSeries[];
    hasMore: boolean;
    tournamentSeriesCount: number | null;
    pageCounts: number | null;
    loading: boolean;
    error?: CombinedError | null;
    refetch: () => void;
};

export const useSearchTournamentSeries = ({
    query,
    pause = false,
}: {
    query: string;
    pause?: boolean;
}): UseSearchTournamentSeriesResult => {
    const [tournamentSeries, setTournamentSeries] = useState<TournamentSeries[]>([]);

    const [result, refetch] = useQuery({
        query: graphql(`
            query searchTournamentSeries($query: String!) {
                searchTournamentSeries(query: $query) {
                    id
                    title
                }
            }
        `),
        variables: {
            query,
        },
        pause,
    });

    useEffect(() => {
        if (result.data?.searchTournamentSeries) {
            setTournamentSeries(result.data.searchTournamentSeries);
        }
    }, [result.data?.searchTournamentSeries]);

    return {
        tournamentSeries: tournamentSeries,
        hasMore: false,
        tournamentSeriesCount: result.data?.searchTournamentSeries?.length ?? null,
        pageCounts: result.data?.searchTournamentSeries.length ? 1 : null,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};
